/** @jsxRuntime classic */
/** @jsx jsx */
import { useRef, useEffect, useState } from "react";
import { jsx } from "@emotion/core";
import Button from "./Button";
import { Flex } from "../shared";
import { mq } from "../responsive";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

const Modal = ({
  visible: initial,
  style,
  children,
  trigger,
  onAction,
  actionText,
}) => {
  const container = useRef();
  const [visible, setVisible] = useState(initial);
  useEffect(() => {
    if (container.current) {
      const target = container.current;
      const handleClickOutside = (event) => {
        if (!target.contains(event.target)) setVisible(false);
      };
      window.addEventListener("click", handleClickOutside);

      return () => {
        window.removeEventListener("click", handleClickOutside);
      };
    }
  }, [container.current]);

  useEffect(() => {
    if (visible && window.innerWidth < 768) {
      disableBodyScroll(document.body);

      return () => {
        enableBodyScroll(document.body);
      };
    }
  }, [visible]);

  const handleAction = (event) => {
    onAction && onAction(event);
    setVisible(false);
  };

  return (
    <div ref={container}>
      <span
        onClick={() => setVisible((visible) => !visible)}
        css={{ userSelect: "none" }}
      >
        {trigger}
      </span>
      <Flex
        css={{
          width: "100%",
          textAlign: "center",
          padding: "2rem 4rem",
          backgroundColor: "#ffffff",
          position: "fixed",
          bottom: 0,
          left: 0,
          transition: "all 0.2s ease-out",
          transform: visible ? "translateY(0)" : "translateY(100%)",
          zIndex: 5,
          boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
          flexDirection: "column",
          alignItems: "center",
          display: "flex",
          overflowY: "auto",
          maxHeight: "80vh",

          [mq.md]: {
            position: "absolute",
            width: "fit-content",
            top: "calc(100% + 2rem)",
            transform: "translateX(-100%)",
            left: "100%",
            borderRadius: "1rem",
            minWidth: "30rem",
            height: "fit-content",
            display: visible ? "flex" : "none",
          },

          ...style,
        }}
      >
        {children}

        <Button
          type="primary"
          onClick={handleAction}
          style={{ margin: "auto" }}
        >
          {actionText || "Done"}
        </Button>
      </Flex>
    </div>
  );
};

export default Modal;
